import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  container: {
    ...Commons.defaultButton,
    backgroundColor: colors.orange,
    position: "fixed",
    bottom: 12,
    left: 0,
    zIndex: 100,
    color: colors.white,
    padding: "6px 12px",
    fontWeight: "bold",
    borderRadius: "0 12px 12px 0",
    boxShadow: colors.shadowWhite,
    letterSpacing: "3px",
    fontSize: 18,
  },
});

export default styles;
